var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "settings-container p-3" },
      [
        _c("div", { staticClass: "mb-4" }, [
          _c("h5", { staticClass: "fw-bold" }, [
            _vm._v(_vm._s(_vm.$t("settings.tabs.tabInfo")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted small" }, [
            _vm._v("Configure your application preferences below.")
          ])
        ]),
        _vm._v(" "),
        _c("ActivitySettingsCard")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }